function wooloraFormatMoney(cents) {
  const currency = window.Shopify?.currency?.active || 'USD';
  const locale = window.Shopify?.locale || 'en-US';
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
}

function wooloraSelectedOptions(root) {
  return Array.from(root.querySelectorAll('[data-product-option]')).map((fieldset) => {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : '';
  });
}

function wooloraFindVariant(variants, selectedOptions) {
  return variants.find((variant) => variant.options.every((option, index) => option === selectedOptions[index]));
}

document.addEventListener('change', function(event) {
  const optionInput = event.target.closest('.woolora-native-chip input[type="radio"]');
  if (!optionInput) return;

  const root = optionInput.closest('[data-etsy-product]');
  const variantsScript = root?.querySelector('[data-product-variants-json]') || document.querySelector('[data-product-variants-json]');
  if (!root || !variantsScript) return;

  const variants = JSON.parse(variantsScript.textContent || '[]');
  const variant = wooloraFindVariant(variants, wooloraSelectedOptions(root));
  if (!variant) return;

  const variantIdInput = root.querySelector('[data-variant-id]');
  const price = root.querySelector('[data-variant-price]');
  const atc = root.querySelector('[data-atc-button]');

  if (variantIdInput) variantIdInput.value = variant.id;
  if (price) price.textContent = wooloraFormatMoney(variant.price);
  if (atc) {
    atc.disabled = !variant.available;
    atc.textContent = variant.available ? 'Add to Cart' : 'Sold out';
  }
});

document.addEventListener('click', function(event) {
  const thumb = event.target.closest('.woolora-etsy-gallery__thumb');
  if (thumb) {
    const productRoot = thumb.closest('.woolora-etsy-product');
    const targetId = thumb.dataset.targetMedia;
    productRoot.querySelectorAll('.woolora-etsy-gallery__thumb').forEach(el => el.classList.toggle('is-active', el === thumb));
    productRoot.querySelectorAll('.woolora-etsy-gallery__frame').forEach(el => el.classList.toggle('is-active', el.dataset.etsyMediaId === targetId));
    return;
  }

  const lightboxTrigger = event.target.closest('[data-lightbox-src]');
  if (lightboxTrigger) {
    const src = lightboxTrigger.dataset.lightboxSrc;
    const lightbox = document.querySelector('[data-woolora-lightbox]');
    const image = document.querySelector('[data-lightbox-image]');
    if (src && lightbox && image) {
      image.src = src;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    return;
  }

  const close = event.target.closest('[data-lightbox-close]');
  const lightbox = event.target.matches('[data-woolora-lightbox]') ? event.target : null;
  if (close || lightbox) {
    const overlay = document.querySelector('[data-woolora-lightbox]');
    const image = document.querySelector('[data-lightbox-image]');
    if (overlay && image) {
      overlay.hidden = true;
      image.src = '';
      document.body.style.overflow = '';
    }
  }
});

document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  const overlay = document.querySelector('[data-woolora-lightbox]');
  const image = document.querySelector('[data-lightbox-image]');
  if (overlay && !overlay.hidden && image) {
    overlay.hidden = true;
    image.src = '';
    document.body.style.overflow = '';
  }
});
